import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

import { Button } from "@/components/common/Button";
import { Field } from "@/components/application-form/Field";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/services/api";
import SEO from "@/components/SEO";


export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [busy, setBusy] = useState(false);

  const [cand, setCand] = useState({
    identifier: "",
    password: "",
  });

  const onCand = (name, value) => {
    setCand((state) => ({
      ...state,
      [name]: value,
    }));
  };

  async function submit(e) {
    e.preventDefault();

    setBusy(true);

    try {
      await login(cand);

      toast.success("Welcome back!");

      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
    <SEO page="login" />
    <div data-testid="login-page">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900">
        Candidate Login
      </h1>

      <p className="mt-2 text-sm text-slate-500">
        Access your application status, admit card, and results.
      </p>

      <form onSubmit={submit} className="mt-6 space-y-5">
        <Field
          label="Email or Phone"
          name="identifier"
          value={cand.identifier}
          onChange={onCand}
          placeholder="Email or 10-digit phone"
          required
          testId="login-identifier"
          autoComplete="username"
        />

        <Field
          label="Password"
          name="password"
          type="password"
          value={cand.password}
          onChange={onCand}
          placeholder="Your password"
          required
          testId="login-password"
          autoComplete="current-password"
        />

        <div className="flex justify-end -mt-2">
  <Link
    to="/forgot-password"
    className="text-sm font-semibold text-amber-600 hover:underline"
  >
    Forgot Password?
  </Link>
</div>

        <Button
          as="button"
          type="submit"
          className="w-full"
          disabled={busy}
          data-testid="login-submit-btn"
        >
          {busy ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            "Sign In"
          )}
        </Button>
      </form>

      <p className="mt-6 text-sm text-slate-500 text-center">
        New to CET?{" "}
        <Link
          to="/apply"
          className="font-semibold text-amber-600 hover:underline"
        >
          Apply for the exam
        </Link>
      </p>
    </div>
    </>
  );
}